import { render, staticRenderFns } from "./one-meal.vue?vue&type=template&id=935f84d2&scoped=true&"
import script from "./one-meal.vue?vue&type=script&lang=js&"
export * from "./one-meal.vue?vue&type=script&lang=js&"
import style0 from "./one-meal.vue?vue&type=style&index=0&id=935f84d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935f84d2",
  null
  
)

export default component.exports